var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeerLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 25,
    viewBox: "0 0 121 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6317 17.3558C71.5162 17.3097 76.8981 18.5548 72.7425 19.533C69.4188 20.3153 66.4881 18.3025 66.5898 15.5803C69.6331 15.5897 79.9154 15.9501 82.1218 15.3297C82.9013 0.636465 63.4311 0.335067 60.882 11.6008C57.5815 26.1869 79.2499 28.5096 81.6317 17.3558Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.314 17.4169C104.352 17.3445 100.939 17.2278 100.122 17.3876C98.6524 17.6747 98.5662 18.8811 96.5851 19.4576C93.2819 20.4189 90.2026 18.4686 90.1183 15.5643C93.0937 15.6349 103.453 15.9276 105.697 15.3567C106.699 0.829247 86.7266 0.0344813 84.3808 11.9525C81.8877 24.6175 100.316 29.8162 105.314 17.4169Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9441 23.9611L51.4331 23.9784C51.4905 23.8535 51.5667 23.6279 51.5899 23.6834L53.6239 18.9673C54.8069 16.0501 59.4817 4.88201 59.6075 3.4716L53.629 3.50689L48.8985 16.0664C46.8166 12.5954 45.6883 6.95331 43.8015 3.46558L37.6798 3.49571C39.335 7.98014 45.2612 21.2767 45.9441 23.9611Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.001 24.0069L113.288 23.9734C113.8 21.2572 113.292 16.5773 113.431 13.6057C113.644 9.033 115.747 9.27498 120.227 9.25517L120.264 4.22266C117.908 4.25625 115.958 4.04527 114 5.28221L112.414 6.35379L111.34 4.3023L107.923 4.26012C107.597 6.37103 107.556 22.327 108.001 24.0069Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8349 1.16211C7.9568 1.6133 6.85772 2.29399 6.39731 4.28607C5.96377 6.1636 6.83308 7.92192 8.27086 8.81957C9.88052 9.82445 18.7324 9.94282 21.1307 9.40769C25.2215 8.49494 25.4157 3.56362 22.4339 1.64949C20.5193 0.420303 12.1967 0.594673 9.8349 1.16211Z",
    fill: "#E21C37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34698 15.3291C6.07816 16.8984 6.27782 16.117 6.91286 17.7789C9.58602 16.7012 14.5786 12.5087 21.6412 16.6061C22.0528 16.845 22.2056 16.9622 22.583 17.1869C23.5426 17.7578 22.65 17.3105 23.642 17.7789C24.6052 16.7193 25.0232 16.6354 25.3282 15.3274C22.3396 13.7982 20.4464 12.1268 15.5409 12.0859C9.69815 12.0373 8.87215 13.8167 5.34698 15.3291Z",
    fill: "#E21C37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3354 16.4563C24.5585 17.2429 23.8889 18.5462 24.7536 20.5753C25.3262 21.9194 26.7959 23.3776 28.8099 22.8558C32.4481 21.9129 29.3405 15.126 26.3354 16.4563Z",
    fill: "#E21C37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.577153 21.9719C4.35713 24.3653 7.31565 21.1715 6.14911 17.7579C5.29619 16.1378 3.41441 15.5337 2.05091 16.9123C1.02935 17.9456 0.207421 20.081 0.577153 21.9719Z",
    fill: "#E21C37"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5916 11.7257L76.4172 11.8178C75.5051 9.84594 74.4384 8.321 71.4935 8.27536C68.6695 8.23145 67.4478 9.82915 66.5916 11.7257Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.181 11.6589L99.9715 11.8355C98.552 7.98045 94.5486 7.41434 91.9506 9.24151C90.6387 10.1646 90.8507 10.3686 90.181 11.6589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeerLogoBlack);
export default __webpack_public_path__ + "static/media/veer-logo-black.12eaf89676faac16ec760ac64f02eca4.svg";
export { ForwardRef as ReactComponent };